export const PENDO_API_KEY = '92feea97-dc02-4f28-5514-382f5f982f72';